import React, { useState, useEffect } from 'react'
import './Blog.scss'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { HashLoader } from 'react-spinners';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Funkcja do czyszczenia excerpt
  const cleanExcerpt = (excerpt) => {
    return excerpt
      .replace(/<\/?p>/g, '') // usuwa <p> i </p>
      .replace(/\[&hellip;\]/g, '...') // zamienia [&hellip;] na ...
      .replace(/&hellip;/g, '...') // na wszelki wypadek, gdyby było samo &hellip;
      .replace(/&#8217;/g, "'") // zamienia &#8217; na apostrof
      .trim(); // usuwa białe znaki z początku i końca
  };

  useEffect(() => {
    axios
      .get('https://marketingv8.scharmach.pl/wp-json/wp/v2/posts?_embed')
      .then((response) => {
        setPosts(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Błąd podczas pobierania danych:', err);
        setError('Błąd podczas pobierania danych');
        setLoading(false);
      });
  }, []);

  if (loading) return (
    <div className='loader-wrapper'>
      <HashLoader color="#000" size={60} />
      <br />
      <p>Loading posts...</p>
    </div>
  );
  if (error) return <p>{error}</p>;


  return (
    <div className='blog'>
      <Helmet>
        <link rel="canonical" href="https://marketingv8.co/blog" />
        <title>Marketing v8 - blog</title>
        <meta name="description" content="Marketing v8 - blog: all about AI and automation" />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marketingv8.co/blog" />
        <meta property="og:title" content="Marketing v8 - blog" />
        <meta property="og:description" content="Marketing v8 - blog: all about AI and automation" />
        <meta property="og:image" content="https://marketingv8.co/logov8.png" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Marketing v8 - blog" />
        <meta name="twitter:description" content="Marketing v8 - blog: all about AI and automation" />
        <meta name="twitter:image" content="https://marketingv8.co/logov8.png" />
      </Helmet>
      <div className='blog-hero'>
        <div className='blog-hero-content'>
          <h1 className='blog-title'>Blog</h1>
          <p className="blog-desc">
            This blog is powered by <strong>Blogomat 360</strong> — our AI-driven content engine designed to turn knowledge into high-quality, scalable articles. <strong>Every post you read here is created with the support of intelligent automation, combining strategy, data, and human insight.</strong>
          </p>
        </div>
      </div>
      <div className='blog-content'>
        <ul className='posts-list'>
          {posts.map((post) => (
            <li key={post.id}>
              <div className='post-card'>

                <img src={post._embedded['wp:featuredmedia'] ? post._embedded['wp:featuredmedia'][0].source_url : 'https://via.placeholder.com/150'} alt={post.title.rendered}
                  className='post-image' />
                <div className='post-info'>
                  <h2 className='post-title'>{post.title.rendered}</h2>
                  <p className='post-date'>{new Date(post.date).toLocaleDateString('pl-PL', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                  <p className='post-excerpt'>{cleanExcerpt(post.excerpt.rendered)}</p>
                  <Link to={`/blog/${post.slug}`} className='read-more'>Read More</Link>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Blog